import React from "react";
import languages from "../../../../data/languages";

export const languageTemplate = {
  destinationAddress: "",
  destinationName: "",
  language: "",
};

const Translations = ({
                        className = "row",
                        translations,
                        onChange
                      }) => (
  <div className={className}>
    {Object.keys(languages)
      .map(lang => {
        const languageItem = translations.find(i => i.language === lang) || {};
        return (
          <div key={lang} className="col-4">
            <label>{languages[lang]}</label>

            <div className="form-group">
              <input
                className="form-control form-control-sm"
                type="text"
                value={languageItem.destinationName || ""}
                onChange={ev => onChange(lang, "destinationName", ev.target.value)}
                placeholder="Destination Name"
              />
            </div>

            <div className="form-group">
                      <textarea
                        className="form-control form-control-sm"
                        value={languageItem.destinationAddress || ""}
                        onChange={ev => onChange(lang, "destinationAddress", ev.target.value)}
                        placeholder="Destination Address"
                      />
            </div>
          </div>
        );
      })}
  </div>
);

export default React.memo(Translations);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/translations.js